<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="infoItemModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <template v-if="dados">
                                {{ dados.search }} <span class="badge badge-secondary ml-2">#{{ dados.id_estoque_item }}</span>
                            </template>
                            <template v-else>
                                Carregando...
                            </template>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados" />

                        <template v-else>

                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Informações</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Consumo</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Compras</a>
                                </li>
                            </ul>
                            
                            <div class="tab-content" id="myTabContent">
                                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <table class="table table-hover mt-3">
                                        <tbody>
                                            <tr>
                                                <th width="20%">
                                                    Consumo Médio Mensal
                                                    <span class="badge badge-dark ml-1">CMM</span>
                                                </th>
                                                <td>{{ consumo_medio_mensal }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    
                                    <p class="alert alert-info mt-3" v-if="false">
                                        <pre>{{ dados }}</pre>
                                    </p>
                                </div>

                                <!-- Exibição do Consumo Mensal -->
                                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                                    <div class="row mt-3">
                                        <div class="col-2">
                                            <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                                <a class="nav-link active" id="grafico-tab" data-toggle="pill" href="#grafico" role="tab" aria-controls="grafico" aria-selected="true">Gráfico</a>
                                                <a class="nav-link" id="tabela-tab" data-toggle="pill" href="#tabela" role="tab" aria-controls="tabela" aria-selected="false">Tabela</a>
                                            </div>
                                        </div>
                                        <div class="col-10">
                                            <div class="tab-content" id="v-pills-tabContent">
                                                <div class="tab-pane fade show active" id="grafico" role="tabpanel" aria-labelledby="grafico-tab">
                                                    
                                                    <div class="card" style="max-width: 720px; b-0">
                                                        <div class="card-body">
                                                            <Chart type="bar" :data="grafico_consumo_mensal" 
                                                                :options="{ 
                                                                    scales: { 
                                                                        xAxes: [{ 
                                                                            stacked: true, 
                                                                            barThickness: 32, 
                                                                            maxBarThickness: 48,
                                                                        }], 
                                                                        yAxes: [{ 
                                                                            stacked: true,
                                                                            ticks: {
                                                                                callback: function(value, index, values) {
                                                                                    return formatQtdGrafico(value);
                                                                                }
                                                                            }
                                                                        }] 
                                                                    } 
                                                                }" />
                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="tab-pane fade" id="tabela" role="tabpanel" aria-labelledby="tabela-tab">
                                                    
                                                    <table class="table table-hover small">
                                                        <thead>
                                                            <tr>
                                                                <th>Local</th>
                                                                <th class="text-right" v-for="(mes, imx) in meses_consumo" :key="imx">
                                                                    {{ $util.getFormatDate(mes, 'MMM').toUpperCase () }}
                                                                </th>
                                                                <th class="text-right">Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(lista, titulo) in locais_consumo" :key="titulo">
                                                                <th>{{ titulo }}</th>
                                                                <td class="text-right" v-for="(mes, imx) in meses_consumo" :key="imx">
                                                                    {{ soma_consumo(lista, mes, titulo) }}
                                                                </td>
                                                                <th class="text-right">
                                                                    {{ soma_consumo(dados ? dados.consumo_mensal : [], null, titulo) }}
                                                                </th>
                                                            </tr>
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <th>Total</th>
                                                                <th class="text-right" v-for="(mes, imx) in meses_consumo" :key="imx">
                                                                    {{ soma_consumo(dados ? dados.consumo_mensal : [], mes) }}
                                                                </th>
                                                                <th class="text-right">
                                                                    {{ soma_consumo(dados ? dados.consumo_mensal : []) }}
                                                                </th>
                                                            </tr>
                                                        </tfoot>
                                                    </table>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>

                                <!-- Compras Realizadas -->
                                <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                    
                                    <table class="table table-hover mt-3">
                                        <thead>
                                            <tr>
                                                <th>Fornecedor</th>
                                                <th>Local</th>
                                                <th>Doc</th>
                                                <th>Data</th>
                                                <th class="text-right">Preço</th>
                                                <th class="text-right">Qtde</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(entrada, iex) in dados.ultimas_entradas" :key="iex">
                                                <td>
                                                    {{ entrada.link.model.nota.fornecedor.search }}
                                                </td>
                                                <td>
                                                    <span v-if="entrada.local">
                                                        {{ entrada.local.st_estoque_local }}
                                                        <div class="small text-muted" v-if="entrada.local.unidade_operacao">
                                                            {{ entrada.local.unidade_operacao.st_nome }}
                                                        </div>
                                                    </span>
                                                </td>
                                                <td>
                                                    <a href="#" @click.prevent="abrir_atalho(entrada)">
                                                        {{ entrada.st_doc }}
                                                    </a>
                                                </td>
                                                <td>
                                                    {{ $util.getFormatDate(entrada.dt_criacao) }}
                                                </td>
                                                <td class="text-right">
                                                    {{ $util.formatMoeda(entrada.dc_valor) }} 
                                                </td>
                                                <td class="text-right">
                                                    {{ entrada.in_quantidade }} 
                                                    <small class="text-muted">
                                                        {{ dados.st_unidade }}
                                                    </small>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            dados: null, 
        };
    },

    components: { 
        AzEmptyState,
    },

    computed: { 
        meses_consumo() { 
            if ( !this.dados )
                return [];
            
            let valores = _.orderBy(this.dados.consumo_mensal, 'mes', 'asc');

            return _.takeRight(
                _.map(
                    _.uniqBy(valores, 'mes'), 
                    mes => mes.mes
                ),
                12
            );
        },

        locais_consumo() { 

            if ( !this.dados )
                return [];
            
            let valores = _.orderBy(this.dados.consumo_mensal, 'mes', 'asc');

            return _.groupBy(valores, item => _.get(item, 'local.search'));

        },

        grafico_consumo_mensal () { 
            if ( !this.dados )
                return [];

            let color = ["red", "blue", "green", "blue", "red", "blue"];

            let labels = this.meses_consumo;
            let series = this.locais_consumo;

            let index = 0;

            series = _.map(series, (items, chave) => { 
                return { 
                    label: chave,
                    fill: false, 
                    backgroundColor: color[index++],
                    data: labels.map(mes => this.dados.consumo_mensal.filter(consumo => consumo.mes == mes && consumo.local.search == chave)
                        .reduce((total, carry) => total + parseInt(carry.qtd), 0))
                }
            });

            let grafico = { 
                labels: labels.map(mes => this.$util.getFormatDate(mes, 'MMM').toUpperCase ()),
                datasets: series,
            };

            return grafico;

        },

        consumo_medio_mensal () { 
            if ( !this.dados )
                return [];

            if ( !this.meses_consumo.length )                
                return 0;

            return Math.round(
                this.soma_consumo(this.dados ? this.dados.consumo_mensal : []) /  this.meses_consumo.length
            );
        }
    },
    
    methods: { 
        abrir_atalho(entrada) { 
            $(".modal").modal("hide");
            this.$router.push({ path: entrada.link.atalho })
        },

        soma_consumo(lista, mes = null, local = null) { 
            return _.filter(lista, consumo => ( consumo.mes == mes || ( !mes && this.meses_consumo.includes(consumo.mes) ) ) && ( consumo.local.search == local || !local ) )
                        .reduce((total, carry) => total + parseInt(carry.qtd), 0);
        },

        formatQtdGrafico(value) { 
            return Math.round(value * 100) / 100;
        },

        abrir(id_estoque_item) { 
            this.dados = null; 
            $('#infoItemModal').modal('show');

            this.$util.load(this, { 
                service: "estoque_items",
                func: "show",
                parms: { 
                    id: id_estoque_item,
                    info_item: true, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    }
}
</script>